/**
 * Sanitizes HTML string by removing dangerous tags and attributes
 * to prevent XSS attacks when rendering HTML content from external sources.
 */
const DANGEROUS_TAGS =
  /<\s*\/?\s*(script|iframe|object|embed|form|input|textarea|button|link|meta|style|base)\b[^>]*>/gi;
const EVENT_HANDLERS = /\s+on\w+\s*=\s*["'][^"']*["']/gi;
const JAVASCRIPT_PROTOCOL = /href\s*=\s*["']\s*javascript:/gi;

export const sanitizeHtml = (html) => {
  if (!html || typeof html !== 'string') return html;
  return html
    .replace(DANGEROUS_TAGS, '')
    .replace(EVENT_HANDLERS, '')
    .replace(JAVASCRIPT_PROTOCOL, 'href="');
};
